import { render } from "./ProfileWidget.vue?vue&type=template&id=43b86655&scoped=true"
import script from "./ProfileWidget.vue?vue&type=script&lang=js"
export * from "./ProfileWidget.vue?vue&type=script&lang=js"

import "./ProfileWidget.vue?vue&type=style&index=0&id=43b86655&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b86655"]])

export default __exports__